// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".right-design-block[data-v-546e80e1]{display:none;width:200px;height:80px}.right-design-block img[data-v-546e80e1]{opacity:1;width:200px;height:80px;pointer-events:none}@media(min-width:1280px){.right-design-block[data-v-546e80e1]{display:block}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
